import clienteAxios from "../config/axios";
import tokenAuth from "../config/token";

export async function authUser(datos) {
    try {
        return clienteAxios.post('/user/auth', datos);
    } catch (error) {
        console.log("error en authUser");
        console.log(error);
    }
}

export async function getUser(token) {
    tokenAuth(token);
    return clienteAxios.get(`/user/auth`);
}

export async function getAllUsers() {
    return clienteAxios.get('/user');
}

export async function updateUser(user) {
    return clienteAxios.put(`/user`, { id: user._id, updates: user });
}

export async function addUser(user, byUser) {
    return clienteAxios.post(`/user`, { user: { ...user, userNameA: byUser.userName, userAID: byUser._id } });
}

export async function deleteUser(user) {
    return clienteAxios.delete(`/user`, { data: { id: user._id } });
}

export async function getUserStats() {
    return clienteAxios.get('/user/stats');
}
